import { Options } from "@sprout/select";
// Static list generated from https://restcountries.com/v3.1/all?fields=name
import countriesJson from "@lib/shared/countries.json";

export const COUNTRIES: Options = countriesJson as Options;
